import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { connect } from "react-redux";
import ContractMaintenanceEditableCell from "src/components/css/ContractMaintenance/ContractMaintenanceEditableCell";
import AxiosConfig from "src/utilities/AxiosConfig";
import logger from '../../../../utilities/logging';
import ContractMaintenanceNewContract from "src/components/css/ContractMaintenance/ContractMaintenanceNewContract";
import { Redirect } from "react-router";
import Checkbox from "src/components/common/checkbox";
import "./ContractMaintenance.css"
import "../../Settings.css"
interface BaseContactInfoType {
    ContractID: number,
    CustomerID: number,
    CustomerName: string,
    Contract_Description: string,
    VP_InCharge: string,
    State: string,
    PaymentTerms: number,
    Discount: string,
    StartDate: string,
    EndDate: string,
    IsAutoRenew: boolean,
    CPI: boolean,
    CPI_Character: string,
    CPIAmount: number,
    CPIEffectiveDate: string,
    FuelSurcharge: boolean,
    SurCharge_Character: string,
    FuelSurchargeAmount: number,
    FuelEffectiveDate: string,
    FuelEndDate: string,
    PriceIncrease: number,
    Comments: string,
    IsActive: boolean,
    IsDistributed: boolean,
    DistributionDate: string,
    IsTermableClause: string,
    TermNotes: string,
    IsLateFee: boolean,
    LateFeePercentage: number,
    LateFeeTerm: number,
    LimitLiability: boolean,
    LiabilityComments: string
}
interface customerDataType {
    CustomerName: string,
    CustomerID: number
}
interface EventDictionary<TValue> {
    [id: string]: TValue
}
function ContractMaintenance(props: { userid: number, username: string }) {
    const [customerData, setCustomerData] = useState<customerDataType[]>()
    const [gridData, setGridData] = useState<BaseContactInfoType[]>()
    const userid = props.userid
    const [acDc, setACDC] = useState<EventDictionary<string>>({})
    const [error, setError] = useState(false)
    const [isActive, setIsActive] = useState(true)

    const getData = async () => {
        try {
            const customerResponse = await axios.get(
                process.env.REACT_APP_API_URL + "/api/billing/ContractCustomers",
                AxiosConfig.configValue("min")
            );

            if (customerResponse.data?.error) {
                throw new Error(customerResponse.data.error.message);
            }

            let data = customerResponse.data;
            let arr: customerDataType[] = [];

            data?.forEach((x: customerDataType) => {
                let obj = { CustomerName: x.CustomerName, CustomerID: x.CustomerID };
                arr.push(obj);
            });

            setCustomerData(arr);

            const contractInfoResponse = await axios.get(
                process.env.REACT_APP_API_URL + `/api/billing/BaseContractInfo/${isActive}`,
                AxiosConfig.configValue("min")
            );

            if (contractInfoResponse.data?.error) {
                throw new Error(contractInfoResponse.data.error.message);
            }

            const contractDetailsResponse = await axios.get(
                process.env.REACT_APP_API_URL + `/api/billing/getContractDetails`,
                AxiosConfig.configValue("min")
            );


            const contractDetails = contractDetailsResponse.data.data

            const mergedData = handleDataMerge(contractInfoResponse.data, contractDetails)

            setGridData([...mergedData]);

        } catch (error) {
            //@ts-ignore
            alert(`There was an error: ${error.message}. Redirecting Home...`);
            logger.Error({
                EventMessage: `ContractMaintenance -> Error : ${JSON.stringify(error)}`,
                EventCategory: "httprequest",
            });
            AxiosConfig.handleError(error);
            setError(true);
        }
    };


    const handleDataMerge = (a: any[], b: any[]) => {
        const mergedData = a.map((contract: any) => {
            const matchingCustomer = b.find((mc: any) => mc.CustomerID === contract.CustomerID);

            if (matchingCustomer) {
                return {
                    ...contract,
                    ...matchingCustomer,
                    ...{ MissingContractDetails: false }
                };
            }

            return {
                ...contract,
                BusinessHoursStart: null,
                BusinessHoursEnd: null,
                MinimumAfterHoursCharge: null,
                LocateIncrements: null,
                FlatRate: null,
                FlatRateTimeLimit: null,
                BillingCycle: null,
                MissingContractDetails: true
            };
        });
        return mergedData
    }

    const sortData = (key: keyof BaseContactInfoType) => {
        let copyData = gridData
        //console.log(key)
        copyData?.sort((a, b) => a[key] > b[key] ? -1 : 1)
        let sortOrder: EventDictionary<string> = {}
        if (acDc[key] === 'arrow_drop_down') {
            copyData?.sort((a, b) => {
                let c = a[key]
                let d = b[key]
                if (c === null || c === "") {
                    return 1
                }
                if (d === null || d === "") {
                    return -1
                }
                if (typeof (c) === "string" && typeof (d) === "string") {

                    return c.toUpperCase() > d.toUpperCase() ? -1 : 1
                }
                return c > d ? -1 : 1
            })
            sortOrder[key] = 'arrow_drop_up'
        }
        else {
            copyData?.sort((a, b) => {
                let c = a[key]
                let d = b[key]
                if (c === null || c === "") {
                    return 1
                }
                if (d === null || d === "") {
                    return -1
                }
                if (typeof (c) === "string" && typeof (d) === "string") {

                    return c.toUpperCase() > d.toUpperCase() ? 1 : -1
                }
                return c > d ? 1 : -1
            })
            sortOrder[key] = 'arrow_drop_down'
        }
        setACDC(sortOrder)
    }
    useEffect(() => {
        getData()
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        setGridData(gridData)
    }, [gridData])

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, [isActive]);  // Watch for changes to isActive

    return (
        <div className="ContractMaintenance Settings main-content col-sm">
            <div className="cmTitle">
                <h3>Contract Maintenance</h3>
                <div className="checkedCM">
                    <Checkbox
                        isChecked={isActive}
                        id="isActive"
                        label="Active"
                        onChange={() => {
                            setIsActive(!isActive);
                        }}
                    />

                </div>
            </div>
            <div className="gridEdit">
                {customerData && customerData.length > 0 && <Table>
                    <thead>
                        <tr className="ContractTableHeader">
                            <th onClick={() => sortData("ContractID")} className="sticky-table-column-left">Contract ID<span className="material-icons">{acDc["ContractID"]}</span></th>
                            <th onClick={() => sortData("CustomerID")}>Customer ID<span className="material-icons">{acDc["CustomerID"]}</span></th>
                            <th onClick={() => sortData("CustomerName")}>Customer Name<span className="material-icons">{acDc["CustomerName"]}</span></th>
                            <th onClick={() => sortData("Contract_Description")}>Contract Description<span className="material-icons">{acDc["Contract_Description"]}</span></th>
                            <th onClick={() => sortData("VP_InCharge")}>VP<span className="material-icons">{acDc["VP_InCharge"]}</span></th>
                            <th onClick={() => sortData("State")}>State<span className="material-icons">{acDc["State"]}</span></th>
                            <th onClick={() => sortData("PaymentTerms")}>Payment Terms<span className="material-icons">{acDc["PaymentTerms"]}</span></th>
                            <th onClick={() => sortData("Discount")}>Discount<span className="material-icons">{acDc["Discount"]}</span></th>
                            <th onClick={() => sortData("StartDate")}>Start Date<span className="material-icons">{acDc["StartDate"]}</span></th>
                            <th onClick={() => sortData("EndDate")}>End Date<span className="material-icons">{acDc["EndDate"]}</span></th>
                            <th onClick={() => sortData("IsAutoRenew")}>Auto Renew<span className="material-icons">{acDc["IsAutoRenew"]}</span></th>
                            <th onClick={() => sortData("CPI")}>CPI<span className="material-icons">{acDc["CPI"]}</span></th>
                            <th onClick={() => sortData("CPI_Character")}>CPI Character<span className="material-icons">{acDc["CPI_Character"]}</span></th>
                            <th onClick={() => sortData("CPIAmount")}>CPI Amount<span className="material-icons">{acDc["CPIAmount"]}</span></th>
                            <th onClick={() => sortData("CPIEffectiveDate")}>CPI Effective Date<span className="material-icons">{acDc["CPIEffectiveDate"]}</span></th>
                            <th onClick={() => sortData("FuelSurcharge")}>Fuel Surcharge<span className="material-icons">{acDc["FuelSurcharge"]}</span></th>
                            <th onClick={() => sortData("SurCharge_Character")}>SurCharge Character<span className="material-icons">{acDc["SurCharge_Character"]}</span></th>
                            <th onClick={() => sortData("FuelSurchargeAmount")}>Fuel Surcharge Amount<span className="material-icons">{acDc["FuelSurchargeAmount"]}</span></th>
                            <th onClick={() => sortData("FuelEffectiveDate")}>Fuel Effective Date<span className="material-icons">{acDc["FuelEffectiveDate"]}</span></th>
                            <th onClick={() => sortData("FuelEndDate")}>Fuel End Date<span className="material-icons">{acDc["FuelEndDate"]}</span></th>
                            <th onClick={() => sortData("PriceIncrease")}>Price Increase<span className="material-icons">{acDc["PriceIncrease"]}</span></th>
                            <th onClick={() => sortData("Comments")}>Comments<span className="material-icons">{acDc["Comments"]}</span></th>
                            <th onClick={() => sortData("IsActive")}>Active<span className="material-icons">{acDc["IsActive"]}</span></th>
                            <th onClick={() => sortData("IsDistributed")}>Distributed<span className="material-icons">{acDc["IsDistributed"]}</span></th>
                            <th onClick={() => sortData("DistributionDate")}>Distribution Date<span className="material-icons">{acDc["DistributionDate"]}</span></th>
                            <th onClick={() => sortData("IsTermableClause")}>Termable Clause<span className="material-icons">{acDc["IsTermableClause"]}</span></th>
                            <th onClick={() => sortData("TermNotes")}>Term Notes<span className="material-icons">{acDc["TermNotes"]}</span></th>
                            <th onClick={() => sortData("IsLateFee")}>Late Fee<span className="material-icons">{acDc["IsLateFee"]}</span></th>
                            <th onClick={() => sortData("LateFeePercentage")}>Late Fee Percentage<span className="material-icons">{acDc["LateFeePercentage"]}</span></th>
                            <th onClick={() => sortData("LateFeeTerm")}>Late Fee Term<span className="material-icons">{acDc["LateFeeTerm"]}</span></th>
                            <th onClick={() => sortData("LimitLiability")}>Limit Liability<span className="material-icons">{acDc["LimitLiability"]}</span></th>
                            <th onClick={() => sortData("LiabilityComments")}>Liability Comments<span className="material-icons">{acDc["LiabilityComments"]}</span></th>
                            {/*@ts-ignore*/}
                            <th onClick={() => sortData("BusinessHoursStart")}>Business Hours Start<span className="material-icons">{acDc["BusinessHoursStart"]}</span></th>
                            {/*@ts-ignore*/}
                            <th onClick={() => sortData("BusinessHoursEnd")}>Business Hours End<span className="material-icons">{acDc["BusinessHoursEnd"]}</span></th>
                            <th className="sticky-table-column-right"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {gridData?.map((x, index) => (
                            <ContractMaintenanceEditableCell data={x} edit={false} index={index} customerData={customerData} key={index} renew={() => getData()} id={userid} />
                        ))}

                    </tbody>
                    <tfoot>
                        <ContractMaintenanceNewContract renew={() => getData()} customerData={customerData} />
                    </tfoot>
                </Table>}
                <div className="cmFixedHeader" onClick={() => sortData("ContractID")}><b>Contract ID</b><span className="material-icons">{acDc["ContractID"]}</span></div>
                <div className="blankCMFixedHeader" />
            </div>
            {
                error ?
                    <Redirect to="/" /> : null
            }
        </div>
    )
}
const mapStateToProps = (state: any) => ({
    username: state.user.userName,
    userid: state.user.userId
})
export default connect(mapStateToProps)(ContractMaintenance)